import styles from './EmailConfirmed.module.css'
import logoUrl from '@/assets/misc/img_taxfyle-symbol.svg'
import { Button } from '@/components/Button'
import { useRootStore } from '@/contexts/root-store-context'

/**
 * The email confirmed view. Displayed when email confirmation is successful.
 */
export default function EmailConfirmedView() {
  const {
    iam: { authStore },
  } = useRootStore()

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <img className={styles.logo} src={logoUrl} alt="Taxfyle logo" />
        <h1 className={styles.title}>You're all set!</h1>
        <p className="text-body-md-light">
          Great news! You have confirmed your email and can now sign in to the
          platform.
        </p>
        <div className={styles.signInButton}>
          <Button
            label="Sign in"
            onPress={() => authStore.login({ returnUrl: null })}
          />
        </div>
      </div>
    </div>
  )
}
